import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { JobsPoolsHeaderTiles, JobsPoolsTable } from '../../containers'
import { jobPoolsOperations } from '../../../../state/ducks/jobs-pools'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { JobsPoolsShape, PaginationShape } from '../../../../prop-types'

class JobsPoolsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchJobsPools = this.fetchJobsPools.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchJobsPools()
  }

  fetchJobsPools () {
    this.props.fetchJobsPools(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchJobsPools())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Jobs Pools</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Jobs Pools'} subTitle={'All Jobs Pools'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <JobsPoolsHeaderTiles all_jobs_pools={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchJobsPools}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All Jobs Pools</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <JobsPoolsTable jobsPools={this.props.jobsPools} params={this.state.params}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </JobsPoolsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
JobsPoolsPage.propTypes = {
  jobsPools: arrayOf(JobsPoolsShape).isRequired,
  fetchJobsPools: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
JobsPoolsPage.defaultProps = {
  jobsPools: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.jobsPools.fetchJobPoolsReducer.loading,
  jobsPools: state.jobsPools.fetchJobPoolsReducer.data.results,
  paginationData: state.jobsPools.fetchJobPoolsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchJobsPools: jobPoolsOperations.list
}

// Export Class
const _JobsPoolsPage = connect(mapStateToProps, mapDispatchToProps)(JobsPoolsPage)
export { _JobsPoolsPage as JobsPoolsPage }
